import React from "react";
import { Card, Stack, Typography } from "@mui/material";
import { LoadingButton } from "../../../shared";

export const UberEatsConnectCard = ({
  reconnectRequired,
  loading,
  disabled,
  onConnect,
}) => {
  return (
    <Card sx={{ p: "48px 24px", mt: "24px" }}>
      <Stack alignItems="center" gap="12px" textAlign="center">
        <Typography variant="h6" fontWeight={600}>
          {reconnectRequired
            ? "Reconnect your Uber Eats account"
            : "Connect your Uber Eats account"}
        </Typography>
        <Typography variant="body2" color="#808080" maxWidth="480px">
          {reconnectRequired
            ? "Your Uber Eats connection has expired. Reconnect to manage your Uber Eats stores."
            : "Connect your Uber Eats account to link your stores and manage the Uber Eats integration."}
        </Typography>
        <LoadingButton
          type="button"
          size="medium"
          variant="contained"
          loading={loading}
          disabled={disabled}
          onClick={onConnect}
          sx={{ mt: "8px" }}
        >
          {reconnectRequired ? "Reconnect Uber Eats" : "Connect Uber Eats"}
        </LoadingButton>
      </Stack>
    </Card>
  );
};
